
import { Card } from 'antd';
import { Outlet } from 'react-router-dom';



const AdminLayout = () => {



    return (
    <>
      <Card>
        <Outlet/>
      </Card>
    </>
  )
}

export default AdminLayout